<template>
  <div class = "st-table">
    <el-card shadow="always" style="width: 100%">
      <el-form label-position="left" label-width="145px" label-colon>
        <el-row :gutter="16" type="flex" justify=start>
          <el-col :span="8">
            <el-form-item label="Week"
                          :span="8"
            >
              <el-date-picker
                v-model="week"
                placeholder="Please Input"
                type="week"
                style="width: 260px"
                :format="start+ ' to '+ end" @change="newDateWeekHandle"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Group">
              <el-select
                v-model="group"
                clearable
                filterable
                placeholder="Please Select"
                style="width: 180px"
              >
                <el-option
                  v-for="item in groupOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Vendor">
              <el-checkbox
                v-model="isVendor"
                :true-label="1"
                :false-label="0"
              >
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="getReportList">
              Search
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <br/>
    <el-card shadow="always"  style="width: 100%" title="Weekly Report">
      <el-form label-position="left" label-width="145px" label-colon>
        <el-row :gutter="16">
          <el-table
            :data="adminReportList"
            style="width: 100%"
            row-key="id"
            :default-expand-all="false"
            border
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            >
            <el-table-column
              prop="fullName"
              label="Full Name"
              width="160"
            >
            </el-table-column>
            <el-table-column
              prop="sumTime"
              label="Sum Time"
              width="100"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.sumTime < 40" style="color: #bd2c00">
                  {{scope.row.sumTime}}
                </span>
                <span v-else-if="scope.row.sumTime === 40" style="color: #669900">
                  {{scope.row.sumTime}}
                </span >
                <span v-else-if="scope.row.sumTime > 40" style="color: #bd2c00">
                  {{scope.row.sumTime}}
                </span >
              </template>
            </el-table-column>

            <el-table-column
              prop="time"
              label="Hour"
              width="80"
            >
            </el-table-column>

            <el-table-column
              prop="category"
              label="Class-Lv1"
              width="100"
            >
            </el-table-column>

            <el-table-column
              prop="category2nd"
              label="Class-Lv2"
              width="160"
            >
            </el-table-column>

            <el-table-column
              prop="category3rd"
              label="Class-Lv3"
              width="160"
            >
            </el-table-column>

            <el-table-column
              prop="subClass"
              label="Sub Class"
              width="120"
            >
            </el-table-column>

            <el-table-column
              prop="percentage"
              label="Progress"
              width="120"
            >
            </el-table-column>

            <el-table-column
              prop="description"
              label="Description"
              width="300"
            >
            </el-table-column>

          </el-table>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import reportApi from '@/api/report.js';
import userApi from "@/api/user";


export default {
  name: "adminReport",
  data() {
    return {
      loading: false,
      week:"",
      start: "",
      end: "",
      group: "",
      isVendor: 0,
      groupOptions: [],
      adminReportList: [],
      hasChildren: true
    }
  },
  methods: {
    getDateWeek() {
      const now = new Date();
      const nowTime = now.getTime();
      const day = now.getDay();
      const oneDayTime = 24*60*60*1000;
      const mondayTime = nowTime - (day-1)*oneDayTime;
      this.week = new Date(mondayTime);
      this.newDateWeekHandle();
    },
    newDateWeekHandle() {
      const now = new Date(this.week);
      const nowTime = now.getTime();
      const day = now.getDay();
      const oneDayTime = 24*60*60*1000;
      const sundayTime = nowTime + (day-2)*oneDayTime;
      const saturdayTime = nowTime + (7-day-1)*oneDayTime;
      this.start = this.$moment(sundayTime).format('YYYY-MM-DD');
      this.end = this.$moment(saturdayTime).format('YYYY-MM-DD');
    },
    getGroupOptions() {
      userApi.getUsers().then(res => {
        let users = res.data.data || []
        let groupSet = new Set()
        for (let user of users) {
          if (user.group) {
            groupSet.add(user.group)
          }
        }
        // Add WCT and WTT options
        groupSet.add('WCT')
        groupSet.add('WTT')
        this.groupOptions = Array.from(groupSet)
      })
    },
    getReportList() {
      let para = {}
      para['week_start'] = this.start
      para['week_end'] = this.end
      if (this.group) {
        para['group'] = this.group
      }
      if (this.isVendor === 1) {
        para['is_vendor'] = 1
      }
      reportApi.getAdminReport(para).then(
        res => {
          this.adminReportList = res.data.data
        }
      )
    }

  },
  created() {
    this.getDateWeek()
  },
  mounted() {
    this.getGroupOptions()
    this.getReportList()
  }
}
</script>

<style lang="scss" scoped>
.st-table {
  padding:10px
}

</style>
